import { ResumeAuthorAge, ResumeAuthorName, ResumeCardTitle } from '@cp/entities/resume';
import { CareerTag } from '@cp/entities/career';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { styled } from '@cp/ds';
import { Box } from '@cp/ds/src/components/box';
import { formatCatalogItemDate } from '@cp/entities/catalogItem';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ReactNode } from 'react';

type UserMainDataProps = {
  data: CatalogItemViewModel;
  onlineStatus: ReactNode;
  isMobile?: boolean;
};

const Root = styled(Stack)(({ theme }) => ({
  padding: '12px 20px',
  maxWidth: '100%',
  [theme.breakpoints.down('md')]: {
    maxWidth: '480px',
    padding: '12px 12px 20px',
  },
}));

const Dot = styled(Box)(({ theme }) => ({
  borderRadius: '50%',
  width: '6px',
  height: '6px',
  backgroundColor: theme.palette['gray light'],
}));

export const UserMainData = ({ data, onlineStatus, isMobile = false }: UserMainDataProps) => {
  const createdDate = formatCatalogItemDate(new Date(data.createdAt), true);

  return (
    <Root gap={0.25}>
      {isMobile ? (
        <>
          <Stack direction="row" justifyContent="space-between">
            <ResumeAuthorName author={data.clientProfile || {}} variant="h2" />
            <CareerTag careerId={data.careerId} />
          </Stack>
          <ResumeAuthorAge age={data.clientProfile?.age} variant="body bold" />
        </>
      ) : (
        <ResumeCardTitle>
          <ResumeAuthorName author={data.clientProfile || {}} variant="h2" />
          <ResumeAuthorAge age={data.clientProfile?.age} variant="body bold" />
        </ResumeCardTitle>
      )}

      <Stack alignItems="center" direction="row" sx={{ mt: 1, gap: 1, '&:empty': { display: 'none' } }}>
        {!isMobile && (
          <>
            <CareerTag careerId={data.careerId} />
            <Typography component="span" variant="small text">
              {onlineStatus}
            </Typography>
            <Dot />
          </>
        )}
        <Typography component="span" sx={{ color: 'grey' }} variant="small text">
          На сайте с {createdDate}
        </Typography>
      </Stack>
    </Root>
  );
};
